// 加密方法
import crypto from 'crypto';
const storageKey = 'smh.client.pc.secret.key';
const storageIv = 'smh.secret.infox';
export function encodeText(text: string): string {
  try {
    const cipher = crypto.createCipheriv('aes-192-cbc', storageKey, storageIv);
    let encodeText = cipher.update(text, 'utf8', 'hex');
    encodeText += cipher.final('hex');
    encodeText = Buffer.from(encodeText, 'hex').toString('base64');
    return encodeText;
  } catch (error) {
    logger.ui.error('[encodeText] error', error);
    return '';
  }
}

// 解密方法
export function decodeText(encodeText: string): string {
  try {
    if (!encodeText) {
      return '';
    }
    const newEncodeText = Buffer.from(encodeText, 'base64').toString('hex');
    const decipher1 = crypto.createDecipheriv('aes-192-cbc', storageKey, storageIv);
    let text = decipher1.update(newEncodeText || '', 'hex', 'utf8');
    text += decipher1.final('utf8');
    return text;
  } catch (error) {
    logger.ui.error('[decodeText] error', error);
    return '';
  }
}
